export enum Colors {
  WHITE = 'var(--vt-c-white)',
  DARK = 'var(--vt-c-text-dark)',
}